import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import s from './SpecialPhoneNumberCartridge.less'

const SPECIAL_NUMBERS_CATEGORIES = {
  purple: 'framboise',
  grey: 'gris',
  green: 'vert'
}

export default function SpecialPhoneNumberCartridge({ number, text, category }) {
  return (
    <div className={classNames(s.SpecialPhoneNumberCartridge, category)}>
      <b>{number}</b>
      <strong>{text}</strong>
    </div>
  )
}

SpecialPhoneNumberCartridge.propTypes = {
  number: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  category: PropTypes.oneOf([
    SPECIAL_NUMBERS_CATEGORIES.purple,
    SPECIAL_NUMBERS_CATEGORIES.grey,
    SPECIAL_NUMBERS_CATEGORIES.green
  ])
}
